/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useModalUpdate from "~components/Modal/hooks/useModalUpdate";

const PriceSearchUpdateModal = () => {
  const { isModalUpdate, openModalUpdate, closedModalUpdate, initial } = useModalUpdate();
  const { parameter: idCliente } = useParams();
  const [pesquisaDadosExtra, setPesquisaDadosExtra] = useState({});
  const [dadosColetados, setDadosColetados] = useState({});

  const onConfirmModal = (values) => {

    const storedData = JSON.parse(localStorage.getItem("clientes_data")) || [];
    const clientIndex = storedData.findIndex((item) => item.id === idCliente);

    if (clientIndex > -1) {
      if (storedData[clientIndex].permissao === false) {
        storedData[clientIndex].permissao = true;
        localStorage.setItem("clientes_data", JSON.stringify(storedData));
      }
    }

    if (values.contato) {
      setPesquisaDadosExtra(values);
    }


  };

  useEffect(() => {
    if (Object.keys(pesquisaDadosExtra).length > 0) {
      setDadosColetados({
        contextoId: pesquisaDadosExtra.contextoId,
        localId: pesquisaDadosExtra.localId,
        contato: pesquisaDadosExtra.contato,
      });

      setPesquisaDadosExtra({});
    }
  }, [pesquisaDadosExtra]);

  return {
    onConfirmModal,
    isModalUpdate,
    openModalUpdate,
    closedModalUpdate,
    initial,
    pesquisaDadosExtra,
    setPesquisaDadosExtra,
    dadosColetados,
    setDadosColetados,
  };
};

export default PriceSearchUpdateModal;
